import React from "react";
import CN from "classnames";
import PT from "prop-types";
import styled, { css } from "styled-components";

import { down, fonts } from "~/src/config/vars";
import { SOffsetStyle } from "~/src/styles/GlobalStyle";

const Headline = ({
    level = 2,
    size = "mid",
    font_weight = "medium",
    children,
    offset = ["bottom-40"],
}) => {
    const headline_size = `size__${size}`;
    const offset_list = offset ? offset.join(" ") : "";
    const classnames = CN(headline_size, offset_list, font_weight);
    return (
        <SOffsetStyle className={offset_list}>
            {level === 1 && <H1 className={classnames}>{children}</H1>}
            {level === 2 && <H2 className={classnames}>{children}</H2>}
            {level === 3 && <H3 className={classnames}>{children}</H3>}
            {level === 4 && <H4 className={classnames}>{children}</H4>}
        </SOffsetStyle>
    );
};

Headline.propTypes = {
    level: PT.oneOf([1, 2, 3, 4]),
    size: PT.oneOf(["tiny", "small", "mid", "large", "huge"]).isRequired,
    font_weight: PT.oneOf(["regular", "medium", "bold"]),
    children: PT.any,
    offset: PT.arrayOf((v) =>
        [
            "top-120",
            "bottom-120",
            "top-80",
            "bottom-80",
            "top-40",
            "bottom-40",
            "top-20",
            "bottom-20",
            "top-0",
            "bottom-0",
        ].includes(v)
    ),
};

const headline_style = css`
    font-family: ${fonts?.ff_title};
    line-height: 1.2;
    &.size__tiny {
        font-size: ${fonts?.fs_18};
    }
    &.size__small {
        font-size: ${fonts?.fs_20};
    }
    &.size__mid {
        font-size: ${fonts?.fs_24};
        ${down("md")} {
            font-size: ${fonts?.fs_20};
        }
    }
    &.size__large {
        font-size: ${fonts?.fs_32};
        ${down("xl")} {
        }
        ${down("lg")} {
            font-size: ${fonts?.fs_28};
        }
        ${down("md")} {
            font-size: ${fonts?.fs_22};
        }
    }
    &.size__huge {
        font-size: ${fonts?.fs_48};
        ${down("xl")} {
        }
        ${down("lg")} {
            font-size: ${fonts?.fs_30};
        }
        ${down("md")} {
            font-size: ${fonts?.fs_24};
        }
    }
    &.regular {
        font-weight: ${fonts?.fw_regular};
    }
    &.medium {
        font-weight: ${fonts?.fw_medium};
    }
    &.bold {
        font-weight: ${fonts?.fw_bold};
    }
    u {
        display: block;
    }
`;

const H1 = styled.h1`
    ${headline_style};
`;
const H2 = styled.h2`
    ${headline_style};
`;
const H3 = styled.h3`
    ${headline_style};
`;
const H4 = styled.h4`
    ${headline_style};
`;

export default Headline;
